export const ENTITIES_ADD = 'sessions/ENTITIES_ADD';
export const NETWORK_START = 'sessions/NETWORK_START';
export const NETWORK_RESET = 'sessions/NETWORK_RESET';
export const NETWORK_ERROR = 'sessions/NETWORK_ERROR';
export const ACTIVE_SET = 'sessions/ACTIVE_SET';



// WEBPACK FOOTER //
// ./src/modules/sessions/actionTypes.js